module.exports = __webpack_public_path__ + "static/media/dierbergs.397af14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/dierbergs.png
// module id = 244
// module chunks = 0